import { render, staticRenderFns } from "./data-template.vue?vue&type=template&id=1ff8a676&scoped=true&"
import script from "./data-template.js?vue&type=script&lang=js&"
export * from "./data-template.js?vue&type=script&lang=js&"
import style0 from "./data-template.scss?vue&type=style&index=0&id=1ff8a676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8a676",
  null
  
)

export default component.exports